import { defineStore } from "pinia";
import { transformSettings } from "~/slices/settings/utils";
import type { Setting } from "~/slices/settings/types";

/**
 * Settings come from the server: build-time initialSettings (data/settings.json)
 * and GET /api/settings (or external API). No client localStorage.
 */
export const useSettingsStore = defineStore("settings", () => {
  const settings: Ref<Record<string, Setting> | null> = ref(null);

  const setSettingsFromApi = (data: Setting[]) => {
    settings.value = transformSettings(data);
  };

  /** Hydrate from build-time initialSettings only when store is still empty (idempotent). */
  const hydrate = (initialFromBuild: Setting[] | null | undefined) => {
    if (!settings.value && initialFromBuild?.length) {
      settings.value = transformSettings(initialFromBuild);
    }
  };

  return { settings, setSettingsFromApi, hydrate };
});
